// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18m915vq{overflow-y:hidden}
._18u0u2gc{margin-left:var(--ds-space-100,8px)}
._1bah1e5h{justify-content:left}
._1bto1l2s{text-overflow:ellipsis}
._1e0c1txw{display:flex}
._1reo15vq{overflow-x:hidden}
._4cvr1h6o{align-items:center}
._o5721q9c{white-space:nowrap}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/dist/esm/ui/issue-like-table/render-type/icon/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,iBAAiB;AAC5B,WAAW,mCAAmC;AAC9C,WAAW,oBAAoB;AAC/B,WAAW,sBAAsB;AACjC,WAAW,YAAY;AACvB,WAAW,iBAAiB;AAC5B,WAAW,kBAAkB;AAC7B,WAAW,kBAAkB","sourcesContent":["._18m915vq{overflow-y:hidden}\n._18u0u2gc{margin-left:var(--ds-space-100,8px)}\n._1bah1e5h{justify-content:left}\n._1bto1l2s{text-overflow:ellipsis}\n._1e0c1txw{display:flex}\n._1reo15vq{overflow-x:hidden}\n._4cvr1h6o{align-items:center}\n._o5721q9c{white-space:nowrap}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
